<template>
  <div class="d-grid col-md-8 col-lg-6 mx-auto">
    <static-alert :message="pageError" @on-hide="pageError=null" />
    <div class="card shadow">
      <div class="card-body d-grid">
        <transition mode="out-in">
          <div v-if="mode===MODE_FETCHING">
            <loading-spinner :small="true" />
          </div>
          <div v-else-if="magicLink">
            {{ magicLink }}
          </div>
          <div v-else-if="mode===MODE_SENT">
            <h2>Check Your Email</h2>
            <p class="lead">We sent a sign-in link to <strong>{{ email || newEmail }}</strong>.</p>
            <p>Don't see it? <strong>Check your spam or junk folder</strong> for an email from <code>mailer@eshopcommand.com</code> and mark it as safe.</p>
          </div>
          <div v-else-if="mode===MODE_PASSWORD">
            <h2 class="mb-3">Welcome Back!</h2>
            <p class="lead">How would you like to sign in to <strong>{{ email }}</strong>?</p>
            <form @submit.prevent="checkPassword">
              <div class="mb-3">
                <input type="password" v-model="passwordForm" placeholder="password" class="form-control form-control-lg" />
              </div>
              <div class="mb-3 d-grid gap-3 align-items-center">
                <button type="submit" class="btn btn-primary btn-lg">
                  <i class="bi bi-lock me-2"></i>
                  Sign In with Password
                </button>
                <i class="hr-text text-muted">or</i>
                <button type="button" class="btn btn-outline-primary btn-lg" @click="sendMagicLink">
                  <i class="bi bi-envelope me-2"></i>
                  Send Me a Sign-In Link
                </button>
                <hr>
                <button type="button" class="btn btn-link" @click="cancel">
                  <i class="bi bi-arrow-left-circle me-1"></i>
                  Start Over
                </button>
              </div>
            </form>
          </div>
          <div v-else-if="mode===MODE_SIGNUP">
            <h2 class="mb-3">
              Welcome to Early Access!
            </h2>
            <p class="lead">
              We'll send your access link to <strong>{{ newEmail }}</strong>.
            </p>
            <p>
              We're in early access — you're getting in on the ground floor and can grow
              with us as we build the reseller analytics tool together.
              Click the link in your email to get started.</p>
            <div class="mb-3 d-grid gap-3 align-items-center">
              <button type="button" class="btn btn-primary btn-lg" @click="sendMagicLink">
                <i class="bi bi-envelope me-2"></i>
                Send Me the Link
              </button>
              <hr>
              <button type="button" class="btn btn-link" @click="cancel">
                <i class="bi bi-arrow-left-circle me-1"></i>
                Start Over
              </button>
            </div>
          </div>
          <div v-else>
            <form @submit.prevent="checkEmail">
              <h1>Sign In</h1>
              <p class="lead">Enter your email address to continue.</p>
              <div class="mb-3">
                <input type="email" v-model="emailForm" placeholder="email" class="form-control form-control-lg" />
              </div>
              <div class="mb-3 d-grid gap-3 align-items-center">
                <button type="submit" class="btn btn-primary btn-lg">
                  Continue
                  <i class="bi bi-arrow-right-circle ms-1"></i>
                </button>
              </div>
            </form>
          </div>
        </transition>
      </div>
    </div>
  </div>

</template>
<script setup>
import LoadingSpinner from "@/app/components/Utils/LoadingSpinner.vue";

const MODE_FETCHING = -1;
const MODE_EMAIL = 1;
const MODE_PASSWORD = 2;
const MODE_SIGNUP = 3;
const MODE_SENT = 4;

import { ref, computed } from "vue";
import { useStore } from "vuex";
import StaticAlert from "@/app/components/Utils/StaticAlert.vue";

const store = useStore();
const fetching = ref(false)
const magicLinkSent = ref(false);
const emailForm = ref();
const email = ref();
const newEmail = ref();
const passwordForm = ref();
const pageError = ref();

const magicLink = computed(() => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get("magic");
})

if (magicLink.value) {
  magicLinkLogin()
}

const mode = computed(() => {
  if (fetching.value) {
    return MODE_FETCHING;
  }
  if (magicLinkSent.value) {
    return MODE_SENT;
  }
  if (newEmail.value) {
    return MODE_SIGNUP
  }
  if (email.value) {
    return MODE_PASSWORD;
  }
  return MODE_EMAIL;
})

function cancel() {
  emailForm.value = null
  email.value = null
  passwordForm.value = null
  newEmail.value = null
  magicLinkSent.value = false
}

function checkEmail() {
  fetching.value = true;
  store.dispatch("checkEmail", emailForm.value)
      .then(valid => {
        if (valid) {
          email.value = emailForm.value;
          fetching.value = false;
        } else {
          newEmail.value = emailForm.value;
          fetching.value = false;
        }
      })
}

function checkPassword() {
  fetching.value = true;
  store.dispatch('login', { email: email.value, password: passwordForm.value })
      .catch( err => {
        console.log(err);
        alert('Incorrect password')
        fetching.value = false;
      })
}

function magicLinkLogin() {
  fetching.value = true;
  store.dispatch('magicLinkLogin', {magicLink: magicLink.value})
      .catch( err => {
        console.log(err);
        pageError.value = 'Your sign-in link is invalid or has expired. Please request a new one.';
        fetching.value = false;
      })
}

function sendMagicLink() {
  fetching.value = true;
  store.dispatch("sendMagicLink", {email: email.value || newEmail.value, returnPath: window.document.location.href})
      .then(data => {
        console.log(data)
        fetching.value = false
        magicLinkSent.value = true;
      })
      .catch(err => {
        pageError.value = err.response?.data?.error || 'Something went wrong. Please try again.';
        console.log(err);
        fetching.value = false;
      })
}

// function login () {
//   routes.replace({ name: "Login"})
// }
</script>
